import React from 'react';
import { CircleUser } from 'lucide-react';
import './examStatusBar.scss';
import { useDispatch, useSelector } from 'react-redux';
import { examLanguageToggle } from '../../../../store/ExamSlice';

const ExamStatusBar = ({
    username,
    answeredCount,
    markedCount,
    notVisitedCount,
    notAnsweredCount,
    examLanguage,
    setExamLanguage,
    hasEnglish,
    hasBengali,
    onReport,
}) => {
    const dispatch = useDispatch();
    const storeVar = useSelector(state => state.question)

    return (
        <div className="exam-statusbar">
            <div className="exam-statusbar__left">
                <div className="exam-statusbar__user">
                    <div className="exam-statusbar__avatar">
                        <CircleUser className="icon" />
                    </div>
                    <span>{username}</span>
                </div>
                <div className="exam-statusbar__language">
                    <span>View in</span>
                    <select
                        value={examLanguage}
                        onChange={(e) => setExamLanguage(e.target.value)}
                        disabled={!(hasEnglish && hasBengali)} // disable when only one language is available
                    >
                        {hasEnglish && <option value="english">English</option>}
                        {hasBengali && <option value="bengali">Bengali</option>}
                    </select>
                </div>
            </div>

            <div className="exam-statusbar__right">
                <div className="exam-statusbar__status green">
                    <div className="circle">C</div>
                    <span>Correct Answer ({answeredCount})</span>
                </div>
                <div className="exam-statusbar__status gray">
                    <div className="circle">N</div>
                    <span>Not Answered ({notVisitedCount})</span>
                </div>
                <div className="exam-statusbar__status red">
                    <div className="circle">W</div>
                    <span>Wrong Answer ({notAnsweredCount})</span>
                </div>
            </div>
        </div>
    );
};

export default ExamStatusBar;







// import React from 'react';
// import { CircleUser } from 'lucide-react';
// import './examStatusBar.scss';
// import { useDispatch, useSelector } from 'react-redux';
// import { examLanguageToggle } from '../../../../store/ExamSlice';

// const ExamStatusBar = ({
//     username,
//     answeredCount,
//     markedCount,
//     notVisitedCount,
//     notAnsweredCount,
//     examLanguage,
//     setExamLanguage,
//     hasEnglish,
//     hasBengali,
//     onReport,
// }) => {
//     const dispatch = useDispatch();
//     const storeVar = useSelector(state => state.question)

//     return (
//         <div className="exam-statusbar">
//             <div className="exam-statusbar__left">
//                 <div className="exam-statusbar__user">
//                     <div className="exam-statusbar__avatar">
//                         <CircleUser className="icon" />
//                     </div>
//                     <span>{username}</span>
//                 </div>

//                 {/* <div className="exam-statusbar__language">
//                     <span>View in</span>
//                     <select defaultValue={viewInLanguage} onChange={handleLanguageChange}>
//                         <option value='english'>English</option>
//                         <option value="bengali">Bengali</option>
//                     </select>
//                 </div> */}
//                 <div className="exam-statusbar__language">
//                     <span>View in</span>
//                     <select
//                         value={examLanguage}
//                         onChange={(e) => setExamLanguage(e.target.value)}
//                         disabled={!(hasEnglish && hasBengali)} // disable when only one language is available
//                     >
//                         {hasEnglish && <option value="english">English</option>}
//                         {hasBengali && <option value="bengali">Bengali</option>}
//                     </select>
//                 </div>





//                 {/* <button onClick={onReport} className="exam-statusbar__report">
//                     <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                     </svg>
//                     Report
//                 </button> */}
//             </div>

//             <div className="exam-statusbar__right">
//                 <div className="exam-statusbar__status green">
//                     <div className="circle">A</div>
//                     <span>Answered ({answeredCount})</span>
//                 </div>
//                 <div className="exam-statusbar__status purple">
//                     <div className="circle">M</div>
//                     <span>Marked ({markedCount})</span>
//                 </div>
//                 <div className="exam-statusbar__status gray">
//                     <div className="circle">N</div>
//                     <span>Not Visited ({notVisitedCount})</span>
//                 </div>
//                 <div className="exam-statusbar__status red">
//                     <div className="circle">N</div>
//                     <span>Not Answered ({notAnsweredCount})</span>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ExamStatusBar;
